export const ManagePasskeyIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <g transform="translate(18 18.5)">
        <path
          d="M13 8C15.21 8 17 6.21 17 4C17 1.79 15.21 0 13 0C10.79 0 9 1.79 9 4C9 6.21 10.79 8 13 8ZM13 2C14.1 2 15 2.9 15 4C15 5.1 14.1 6 13 6C11.9 6 11 5.1 11 4C11 2.9 11.9 2 13 2Z"
          fill={fill}
        />
        <path
          d="M13.0002 11C15.0502 11 16.8102 12.24 17.5802 14H19.7102C18.8502 11.11 16.1702 9 13.0002 9C10.7402 9 8.7302 10.08 7.4502 11.74L8.8802 13.17C9.7802 11.86 11.2902 11 13.0002 11Z"
          fill={fill}
        />
        <path
          d="M15 15H7.86C7.54 13.75 6.63 12.73 5.43 12.28C4.98 12.11 4.5 12 4 12C1.79 12 0 13.79 0 16C0 18.21 1.79 20 4 20C5.86 20 7.41 18.72 7.86 17H11.5V19H13.5V17H15V19H17V17C17 15.8954 16.1046 15 15 15ZM4 18C2.9 18 2 17.1 2 16C2 14.9 2.84 14.06 3.9 14.01H4C5.1 14 6 14.9 6 16V16.1C5.94 17.16 5.07 18 4 18Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export const RespManagePasskeyIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <g transform="translate(2 2)">
        <path
          d="M13 8C15.21 8 17 6.21 17 4C17 1.79 15.21 0 13 0C10.79 0 9 1.79 9 4C9 6.21 10.79 8 13 8ZM13 2C14.1 2 15 2.9 15 4C15 5.1 14.1 6 13 6C11.9 6 11 5.1 11 4C11 2.9 11.9 2 13 2Z"
          fill={fill}
        />
        <path
          d="M13.0002 11C15.0502 11 16.8102 12.24 17.5802 14H19.7102C18.8502 11.11 16.1702 9 13.0002 9C10.7402 9 8.7302 10.08 7.4502 11.74L8.8802 13.17C9.7802 11.86 11.2902 11 13.0002 11Z"
          fill={fill}
        />
        <path
          d="M15 15H7.86C7.54 13.75 6.63 12.73 5.43 12.28C4.98 12.11 4.5 12 4 12C1.79 12 0 13.79 0 16C0 18.21 1.79 20 4 20C5.86 20 7.41 18.72 7.86 17H11.5V19H13.5V17H15V19H17V17C17 15.8954 16.1046 15 15 15ZM4 18C2.9 18 2 17.1 2 16C2 14.9 2.84 14.06 3.9 14.01H4C5.1 14 6 14.9 6 16V16.1C5.94 17.16 5.07 18 4 18Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
